import axios from "axios";
import { ENDPOINT } from "../ENDPOINT";

export const ReportServices = {

    getAllReportByPayMode: async (data ) => {

        console.log(data);
        
        try {
            const response = await axios.post(ENDPOINT.reportByPayMode, data);
            return response.data;
        } catch (error) {
            console.error("Error fetching Report:", error.message);
            throw error;
        }
    },
   
    getAllFinReport: async ( ) => {
        
        try {
            const response = await axios.get(ENDPOINT.reportByPayMode);
            return response.data;
        } catch (error) {
            console.error("Error fetching Report:", error.message);
            throw error;
        }
    },



}